import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import {  getHexabindProperties } from "./hexabindService";
import { isAxiosError } from "axios";
import { setGlobalMsgAlerts } from "../../components/GloablMsgAlerts/globalMsgAlertsSlice";

interface StateType {
  status: "idle" | "loading" | "failed" | "successful";
  properties: {
    moleculeData: any[];
    jobId: string;
  };
  singleSmileData: any | null;
}


const initialState: StateType = {
  status: "idle",
  properties: {
    moleculeData: [],
    jobId: "",
  },
  singleSmileData: null,
};


export const fetchHexabindProperties = createAsyncThunk(
  "hexabind/fetchHexabindProperties",
  async (task_id: string, { dispatch }) => {
    try {
      const reponse = await getHexabindProperties(task_id);
      return reponse.data;
    } catch (error) {
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg,
          isAlert: true,
          color: "error",
        })
      );
      throw msg;
    }
  }
);

export const hexabindSlice = createSlice({
  name: "hexabind",
  initialState,
  reducers: {
    setSingleSmileData: (state, action) => {
      state.singleSmileData = action.payload;
    },
    updateSmilesById: (state, action) => {
      const { id } = action.payload;
      const sliceData = original(state.singleSmileData);
      const smilesData = sliceData.data[sliceData.evaluationIds[id] - 1];
      state.singleSmileData.id = id;
      state.singleSmileData.rowData = smilesData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHexabindProperties.fulfilled, (state, action) => {
        state.properties.moleculeData = action.payload.results;
        state.properties.jobId = action.payload.task_id;
        state.status = "successful";
      })
      .addCase(fetchHexabindProperties.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(fetchHexabindProperties.pending, (state) => {
        state.status = "loading";
      });
  },
});
export const { updateSmilesById, setSingleSmileData } =
  hexabindSlice.actions;
export default hexabindSlice.reducer;

